(function() { window.GUID_4b05405d_5a6d_47dc_84da_ec55518200b7 = { getGuid: function() { return "4b05405d-5a6d-47dc-84da-ec55518200b7"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-career-overview",
                        callback: (accordion, e) => {
                            accordion.$Content.offon("click.accordionCareerOverviewTabMenuClicked", `#tabmenu-career-overview-${accordion.ContentId}`, (e) => {
                                const $closestTabMenuItem = $(e.target).closest(".tab-menu-item");
                                if ($closestTabMenuItem.length) {
                                    const { popupUrl } = $closestTabMenuItem.data("html");
                                    if (popupUrl) {
                                        accordion.RefreshContent(() => { }, popupUrl);
                                    }
                                }
                            });
                            accordion.$Content.offon("click.accordionCareerOverviewMainActionClicked", "#button-persona-wall-show-more-options", (e) => {
                                const $button = $(e.currentTarget);
                                const { popupUrl } = $button.data("html");
                                if (popupUrl != null) {
                                    let _triggerClickSelector;
                                    CS.Controls.Popup.ShowAjaxModal(popupUrl, {}, ({ popup, isPopup }) => {
                                        if (!isPopup) {
                                            return;
                                        }
                                        popup.$Control.offon("click.secondaryActionClicked", ".button:not(a)", (e) => {
                                            const $button = $(e.currentTarget);
                                            const { triggerClickSelector, closePopup } = $button.data("html");
                                            _triggerClickSelector = triggerClickSelector;
                                            if (closePopup != null && closePopup == true) {
                                                popup.Close();
                                            }
                                        });
                                        popup.$Control.offon("click.secondaryActionClickedAlt", ".item:not(a)", (e) => {
                                            const $button = $(e.currentTarget);
                                            const closePopup = $button.data("close-popup");
                                            const triggerClickSelector = $button.data("trigger-click-selector");
                                            _triggerClickSelector = triggerClickSelector;
                                            if (closePopup != null && closePopup == true) {
                                                popup.Close();
                                            }
                                        });
                                    }, ({ popup }) => {
                                        if (_triggerClickSelector != null &&
                                            typeof _triggerClickSelector === "string") {
                                            $(_triggerClickSelector).trigger("click");
                                        }
                                    }, true);
                                }
                            });
                            accordion.$Content.offon("click.personaWallOverviewItemClicked", ".overview .overview-item", (e) => {
                                const $item = $(e.currentTarget);
                                const $target = $(e.target);
                                if (!$target.closest("[data-trigger-player-feature-popup-on-click='true']").length) {
                                    const id = $item.attr("id");
                                    const { url } = $item.data("html");
                                    // if (id == "overview-item-matches") {
                                    //   //const $tabsMenu = $("#tabmenu-persona-wall");
                                    //   const eventsWallV2PopupUrl = $(
                                    //     "input#EventsWallV2PopupUrl"
                                    //   ).val();
                                    //   if (eventsWallV2PopupUrl != null) {
                                    //     // this.showEventSelectionForMatchesWallPopup(
                                    //     //   eventsWallV2PopupUrl
                                    //     // );
                                    //   }
                                    //   //if ($tabsMenu.length) {
                                    //   //const currentTab = $tabsMenu.attr("data-current-tab");
                                    //   //if (currentTab == "overview") {
                                    //   //    const $matchesV2Section = this.$Container.find(".accordion-matches-v2");
                                    //   //    if ($matchesV2Section.length) {
                                    //   //        MasterPage.ScrollToSection($matchesV2Section);
                                    //   //    }
                                    //   //} else {
                                    //   //}
                                    //   //}
                                    // } else if (url != null) {
                                    //   Nav.Go(url);
                                    // }
                                    if (url != null) {
                                        CS.Nav.Go(url);
                                    }
                                }
                            });
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=section.js.map
